module.exports = __webpack_public_path__ + "static/media/custom-payment.df9dc368.png";